import React, { useEffect } from 'react'
import { useHistory, useLocation } from 'react-router-dom'

import { useAccountSettings } from 'redux/hooks/SignedInAccount'

import { EAccountRole } from 'types/GlobalAccount'

const RedirectWrapper = ({ children }) => {
  const history = useHistory()
  const location = useLocation()
  const { account, allowAccess } = useAccountSettings()

  useEffect(() => {
    // Every signed-in user approves their own MCP connections.
    if (window.location.pathname === '/mcp/consent') {
      return
    }

    const productPath = window.location.pathname.split('/')[1]

    let defaultPath = '/'
    const accessHubUser = account?.role === EAccountRole.ACCESS_HUB
    const companyGroupUser = !!account?.is_company_group
    const economist = !!account?.has_access_to_economy_settings

    if (accessHubUser) {
      defaultPath = '/access-hub'
    }

    if (location.state && location.state.redirectPath) {
      history.push(location.state.redirectPath, {})
    } else if (!productPath.includes('access-hub') && accessHubUser) {
      history.push(defaultPath)
    } else if (
      companyGroupUser &&
      !productPath.includes('dashboards') &&
      !productPath.includes('resources') &&
      !productPath.includes('templates')
    ) {
      history.push(defaultPath)
    } else if (
      account &&
      account.role !== EAccountRole.ADMIN &&
      !account.is_homepal_user &&
      // allow economy settings for users with economy access
      (!economist || window.location.pathname !== '/settings/economy') &&
      (!economist || window.location.pathname !== '/settings') &&
      !productPath.includes('dashboards') &&
      !productPath.includes('resources') &&
      !productPath.includes('lists') &&
      !productPath.includes('insight-studio') &&
      !productPath.includes('access-hub') &&
      !productPath.includes('templates') &&
      !productPath.includes('groups') &&
      !productPath.includes('key-metrics') &&
      !productPath.includes('tasks') &&
      // the analyses flow: Resultat, Analyspaket and Analyser
      (!['analysis-types', 'results', 'analyses'].some((path) =>
        productPath.includes(path)
      ) ||
        !account.allow_access_to_analyses) &&
      (!productPath.includes('metrics') || !allowAccess.allow_key_metrics)
    ) {
      history.push(defaultPath)
    } else if (
      productPath.includes('callback') ||
      productPath === '' ||
      productPath === 'login'
    ) {
      history.push(defaultPath)
    }
  }, [window.location.pathname, account])

  return <>{children}</>
}

export default RedirectWrapper
